import React from 'react';
import { map, startCase } from 'lodash';
import { Table } from 'react-bootstrap';

export default ({ headers = [], data = [], onClick, ...props }) => (
  <Table responsive {...props}>
    <thead>
      <tr>
        {headers.map((f) => (
          <th key={f}>{startCase(f)}</th>
        ))}
      </tr>
    </thead>
    <tbody>
      {map(data, (row, idx) => (
        <tr key={idx} onClick={() => onClick && onClick(row)}>
          {map(headers, (header) => (
            <td key={row[header]}>{row[header]}</td>
          ))}
        </tr>
      ))}
    </tbody>
  </Table>
);



// WEBPACK FOOTER //
// ./src/components/GenericTable.js